import { ValidationService } from "../steps/runtime.js"
import path from "node:path"
import { existsSync } from "node:fs"

export function createValidationServices(): ValidationService {
  return {
    findParentGitDirectoryLocation() {
      const currentDirectory = path.resolve(process.cwd())
      if (hasGitMetadata(currentDirectory)) {
        return null
      }

      return findParentGitRoot(currentDirectory)
    },
  }
}

function findParentGitRoot(startDirectory: string): string | null {
  let currentDirectory = path.dirname(startDirectory)

  while (currentDirectory !== path.dirname(currentDirectory)) {
    if (hasGitMetadata(currentDirectory)) return currentDirectory
    currentDirectory = path.dirname(currentDirectory)
  }

  return hasGitMetadata(currentDirectory) ? currentDirectory : null
}

function hasGitMetadata(directoryPath: string): boolean {
  return existsSync(path.join(directoryPath, ".git"))
}
